import {isNullOrUndefined} from 'util'

export const defaultNumbersFor = (defaults, type, key = '', inWeight = -1) => {
  if (key === '' && inWeight < 0) {
    return defaults[type]
  }

  if (inWeight < 0) {
    return {
      ...defaults['global'],
      ...defaults[type][key],
    }
  }

  var otherDefaults = {}
  if (type === 'backgrounder') {
    type = 'finishing'
    otherDefaults = {...defaults['backgrounder']}
  } else if (type === 'projection') {
    const index = defaultsIndexFor(defaults, 'projection', key, inWeight)
    otherDefaults = defaults['projection'][key][index]
    type = 'finishing'
  }

  const index = defaultsIndexFor(defaults, type, key, inWeight)
  if (isNullOrUndefined(index)) {
    return {
      ...defaults['global'],
      ...defaults[type][key],
    }
  } else {
    return {
      ...defaults['global'],
      ...defaults[type][key][index],
      ...otherDefaults,
    }
  }
}

export const defaultsIndexFor = (defaults, type, key, inWeight) => {
  var possibleDefaults = defaults[type][key]
  if (!(possibleDefaults instanceof Array)) {
    return null
  }

  var foundIndex = null
  possibleDefaults.forEach((value, index) => {
    const inWeightStart = value.inWeightStart
    if (inWeightStart < inWeight) {
      foundIndex = index
    }
  })

  return foundIndex
}



// WEBPACK FOOTER //
// ./src/helpers/defaultNumbers.js